import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface EmailProps {
  id: number;
  email: string;
}

export const Email = types.model({
  id: types.number,
  email: types.string,
});

export type EmailSnapshot = SnapshotIn<typeof Email>;
export type EmailInstance = Instance<typeof Email>;
